import React from 'react';
import PropTypes from 'prop-types';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { StockLevelsPropType } from '../../../../../../prop-types/stock-levels';

import { MappedStockLevels } from './mapped-stock-levels';
import { InventoryProviderStockLevels } from './inventory-provider-stock-levels';
import { UntrackedStockLevels } from './untracked';

import { shipmentItemInventoryStatus } from '../../../../fulfillment-plan/sections/shipment-items/helpers/get-item-inventory-status';
import { InventoryService } from '../../../../../../services/inventory-service';

import style from './item-stock.module.less';

export const ItemStockComponent = ({
  stockLevels,
  isLoading = false,
  itemInventoryStatus,
  shouldShowInventoryInfoUiTreatments = false,
}) => {
  const isInventoryProviderDrivenStockLevels = stockLevels.some((stock) => {
    return stock.type === InventoryService.StockLevelQuantityType.InventoryProviderSpecified;
  });

  if (isLoading) {
    return <LoadingIndicator className={style.loading} theme='grey' />;
  }

  if (!stockLevels.length || itemInventoryStatus === shipmentItemInventoryStatus.isUntracked) {
    return <UntrackedStockLevels />;
  }

  if (isInventoryProviderDrivenStockLevels) {
    return (
      <InventoryProviderStockLevels
        itemInventoryStatus={itemInventoryStatus}
        shouldShowInventoryInfoUiTreatments={shouldShowInventoryInfoUiTreatments}
        stockLevels={stockLevels}
      />
    );
  }

  return (
    <div className={style['stock-level-wrapper']}>
      <MappedStockLevels
        itemInventoryStatus={itemInventoryStatus}
        shouldShowInventoryInfoUiTreatments={shouldShowInventoryInfoUiTreatments}
        stockLevels={stockLevels}
      />
    </div>
  );
};

ItemStockComponent.propTypes = {
  stockLevels: StockLevelsPropType.isRequired,
  isLoading: PropTypes.bool,
  itemInventoryStatus: PropTypes.string,
  shouldShowInventoryInfoUiTreatments: PropTypes.bool,
};
